module.exports = __webpack_public_path__ + "5ee8ea6ce074335babb3d86acd34c72d.svg";